// src/app/services/organization.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment'; 
import { Observable } from 'rxjs';
import { NO_FILTERS, ProgressFilters } from '../@Modules/assessment-status-chart/progress-filters';
@Injectable({
  providedIn: 'root',
})


export class OrganizationService {
  baseUrl = environment.baseUrl;

  private apiUrl = `${this.baseUrl}/client-admin/organization-list/`;

  constructor(private http: HttpClient) {}

  getOrganizations(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  activateSuperadmin(orgId: string): Observable<any> {
    const url = `${this.baseUrl}/client-admin/organization/${orgId}/activate/`;
    return this.http.post(url, {});
  }

   deleteOrganization(orgId: string): Observable<any> {
    const url = `${this.baseUrl}/client-admin/organization/${orgId}/`;
    return this.http.delete(url); 
  }

  getAssessmentProgressList(orgId: string, assessmentType?: string | null): Observable<any> {
    let url = `${this.baseUrl}/client-admin/organization/${orgId}/assessment-progress/`;
    if (assessmentType) url += `?assessment_type=${assessmentType}`;
    return this.http.get<any>(url);
  }

  /** Progress as xlsx: one client when orgId is given, otherwise every client. */
  exportAssessmentProgress(orgId?: string | null, assessmentType?: string | null): Observable<Blob> {
    const params: string[] = [];
    if (orgId) params.push(`organization_id=${orgId}`);
    if (assessmentType) params.push(`assessment_type=${assessmentType}`);
    const query = params.length ? `?${params.join('&')}` : '';
    return this.http.get(`${this.baseUrl}/client-admin/assessment-progress/export/${query}`, {
      responseType: 'blob',
    });
  }

  /** Assessments of every active client counted by status. */
  /** Status counts of activated clients' assessments, plus the filter options. */
  getAssessmentProgressSummary(filters: ProgressFilters = NO_FILTERS): Observable<any> {
    let params = new HttpParams();
    if (filters.assessmentType) params = params.set('assessment_type', filters.assessmentType);
    filters.organizationIds.forEach((id) => (params = params.append('organization_id', id)));
    if (filters.period) params = params.set('period', filters.period);
    return this.http.get<any>(`${this.baseUrl}/client-admin/assessment-progress/summary/`, { params });
  }

  /** Per client assessments / filled / total, the Summary sheet of the progress export. */
  getAssessmentProgressClientSummary(assessmentType?: string | null): Observable<any> {
    let url = `${this.baseUrl}/client-admin/assessment-progress/summary/clients/`;
    if (assessmentType) url += `?assessment_type=${assessmentType}`;
    return this.http.get<any>(url);
  }

  /** Every assessment of every active client with its filled rate per classification. */
  getAssessmentProgressRows(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/client-admin/assessment-progress/assessments/`);
  }

  /**
   * Portal usage per client. range is all | 7d | 30d | 90d | quarter | custom;
   * custom needs dateFrom and dateTo as YYYY-MM-DD, both inclusive.
   */
  getAssessmentUsageSummary(range: string, dateFrom?: string, dateTo?: string): Observable<any> {
    let params = new HttpParams().set('range', range);
    if (range === 'custom') {
      params = params.set('date_from', dateFrom || '').set('date_to', dateTo || '');
    }
    return this.http.get<any>(`${this.baseUrl}/client-admin/assessment-usage/summary/`, { params });
  }

  getAssessmentOverview(assessmentId: string): Observable<any> {
    const url = `${this.baseUrl}/client-admin/assessment-overview/?assessment_id=${assessmentId}`;
    return this.http.get<any>(url);
  }
}
